import React from 'react'
import cx from 'classnames'
import { TypeOf } from 'io-ts'

import { DateInput, Props as DateInputProps } from '../DateInput'
import { SearchBarButton } from '../SearchBarButton'
import { PersonPicker, Props as PersonPickerProps } from '../PersonPicker'
import { messages } from '../messages'
import { useIntl } from '../../utils/intl'

import { SearchField } from './SearchField'
import {
  AutoCompleteItem,
  AutoCompleteItems,
} from './decoders/AutoCompleteDecoder'

export type Props = {
  onSearchButtonClick: React.MouseEventHandler<HTMLButtonElement>
  value: string
  autocompleteItems: TypeOf<typeof AutoCompleteItems> | null | undefined
  hasGoogleResults?: boolean
  dateInputProps: DateInputProps
  personPickerProps: PersonPickerProps
  isSearchFieldFocused: boolean
  handleSearchFieldFocus: () => void
  handleSearchFieldBlur: () => void
  onAutocompleteItemClick?: (item: TypeOf<typeof AutoCompleteItem>) => void
  onChange: (value: string) => void
  onClear: React.MouseEventHandler<HTMLButtonElement>
  onSubmit: React.FormEventHandler<HTMLFormElement>
}

export const SearchBar = ({
  onSearchButtonClick,
  value,
  autocompleteItems,
  hasGoogleResults,
  dateInputProps,
  personPickerProps,
  isSearchFieldFocused,
  handleSearchFieldFocus,
  handleSearchFieldBlur,
  onAutocompleteItemClick,
  onClear,
  onSubmit,
  onChange,
}: Props) => {
  const format = useIntl()

  return (
    <div className='flex w-full justify-center'>
      <div className='w-full mx-2 sm:w-4/6 md:w-4/5 lg:w-10/12 xl:w-4/5 2xl:w-7/12 p-2 bg-white bg-opacity-60 rounded-md lg:flex relative lg:static'>
        <div className='flex-1'>
          <SearchField
            isFocused={isSearchFieldFocused}
            value={value}
            autocompleteItems={autocompleteItems}
            hasGoogleResults={hasGoogleResults}
            onAutocompleteItemClick={onAutocompleteItemClick}
            onClear={onClear}
            onSubmit={onSubmit}
            onChange={onChange}
            onFocus={handleSearchFieldFocus}
            onBlur={handleSearchFieldBlur}
          />
        </div>
        <div className='md:flex lg:ml-2 mt-2 lg:mt-0'>
          <div
            className={cx('flex-1 min-h-search-bar-row', {
              'block md:flex': !isSearchFieldFocused,
              'md:hidden': isSearchFieldFocused,
            })}
          >
            <div className='flex flex-1 min-h-search-bar-row mb-2 md:mb-0'>
              <DateInput {...dateInputProps} className='flex-1' />
            </div>
            <div className='flex min-h-search-bar-row md:ml-2'>
              <PersonPicker {...personPickerProps} className='flex-1' />
            </div>
          </div>
          <div>
            <SearchBarButton
              className='w-full md:w-44 lg:w-40 py-2 md:py-0 mt-2 md:mt-0 md:ml-2 h-full'
              form='searchBarForm'
              type='submit'
              onClick={onSearchButtonClick}
            >
              {format(messages.DO_SEARCH)}
            </SearchBarButton>
          </div>
        </div>
      </div>
    </div>
  )
}
